import { fg } from '@confluence/feature-gating';

/**
 * Height the top nav contributes to the banner stack offset.
 *
 * Nav4 is fully rolled out, so the height is 48px by default and 56px when the app switcher
 * improvements gate is on.
 *
 * Callers should resolve this once and hold the result — `BannerStateContainer` does so in its
 * constructor, and `useBannerTotalHeight` does so in a mount-scoped `useMemo`. It is not reactive.
 */
export const resolveTopNavHeight = (): number => {
	// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
	if (fg('platform_dst_ads_appswitcher_improvements')) {
		return 56;
	}

	return 48;
};
